import { render, staticRenderFns } from "./BuildingCodeList.vue?vue&type=template&id=4ea64e0c&"
import script from "./BuildingCodeList.vue?vue&type=script&lang=js&"
export * from "./BuildingCodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports